<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item>我的报告</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="left">测评报告</div>
        </div>
        <div class="center">评测报告包含哪些？怎么看？</div>
        <!-- <div class="Control_Strip">
        <div class="block">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </div>
        <div class="but">
          <el-button type="primary">查询</el-button>
        </div>
      </div> -->
        <div class="btn">
          <el-table
            :row-style="{ height: 30 + 'px' }"
            :data="tableData"
            style="width: 100%; color: '#333333'; font-weight: bold"
            border
            stripe
            :header-cell-style="{
              background: '#d7e0fa',
              color: '#333333',
            }"
          >
            <el-table-column prop="title" label="测评报告" align="center">
            </el-table-column>
            <el-table-column prop="roleName" label="评测角色" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="评测时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="
                    goReport(
                      scope.row.type,
                      scope.row.reportsId,
                      scope.row.createTime
                    )
                  "
                  >查看报告</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBusCustomReports } from "@/api/home";
export default {
  name: "HXreport",

  data() {
    return {
      tableData: [],
    };
  },

  async mounted() {
    const res = await GetBusCustomReports(
      this.$store.state.user.studentInfo.userId
    );
    let arr = res.data||res.result.customReports;
    this.tableData = arr.reverse();
  },

  methods: {
    goReport(type, id, createTime) {
      // type = 0  综合报告
      // type = 4  风格报告
      // type = 1  sas报告
      if (type === 0) {
        let routeData = this.$router.resolve({
          path: "/synthesize",
          query: { id, createTime },
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({path:'/synthesize',query:{ id, createTime}})
      }
      if (type === 1) {
        let routeData = this.$router.resolve({
          path: "/sasAnxiety",
          query: { CustomScaleId: id },
        });
        window.open(routeData.href, "_blank");
      }
      if (type === 4) {
        let routeData = this.$router.resolve({
          path: "/StyleAnxiety",
          query: { CustomScaleId: id },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  background-color: #fff;
  margin-top: 10px;
  min-width: 1050px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  .content {
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    box-sizing: border-box;
    width: 100%;
    .top {
      margin-bottom: 8px;
      .left {
        font-size: 22px;
        color: #333;
      }
    }
    .center {
      font-size: 16px;
      color: #666;
      margin-bottom: 53px;
    }
    .btn {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
    }
    .Control_Strip {
      display: flex;
      .but {
        margin-left: 50px;
      }
    }
    .btn {
      margin-top: 30px;
      width: 100%;
    }
  }
  ::v-deep .el-button--primary {
    background-color: #3964e6 !important;
    border-color: #3964e6 !important;
  }
  ::v-deep .el-button--text {
    color: #3964e6 !important;
    font-weight: bold;
  }
}
</style>